/**
 * Veridex Protocol SDK - Starknet Chain Module
 */

export { StarknetClient } from './StarknetClient.js';
export type { StarknetClientConfig } from './StarknetClient.js';
